export interface IShippingClassMessages {
    shipping_class_poa_message_website: { [key: string]: string };
    shipping_class_poa_message_order: { [key: string]: string };
}
